import WebhookOverview from '@/modules/integrations/types/webhook/WebhookOverview'
import WebhookSettings from '@/modules/integrations/types/webhook/WebhookSettings'

export default Object.freeze({
  type: 'webhook',
  title: 'Integrations_Webhook',
  category: 'Integrations_Webhook_Category',
  description: 'Integrations_Webhook_Description',
  image: require('@/img/integrations/webhook.png'),
  requiresAdmin: false,
  components: {
    overview: WebhookOverview,
    settings: WebhookSettings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/webhooks-integration'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/webhook/index.js